import { useState } from "react";
import Slider from "./Slider";

export default function Hero({ slides, title, domain }) {
  const [activeSlide, setActiveSlide] = useState(0);
  const [swiper, setSwiper] = useState(null);

  return (
    <div className="md:pt-11 pt-5 px-4 xl:px-0 bg-white md:bg-transparent">
      <h2 className="md:min-h-[32px] title2 text-gray-650">{title}</h2>
      <div className="inner-container overflow-hidden bg-white mt-5 md:mt-10 flex-col md:flex-row-reverse md:shadow-slider rounded-10 flex md:gap-8 justify-between">
        <Slider
          swiper={swiper}
          setSwiper={setSwiper}
          slides={slides}
          setActiveSlide={setActiveSlide}
          domain={domain}
        />
        <div className="w-full grid-cols-2 grid md:py-10 py-4 md:px-8">
          {slides?.map(({ logoUrl }, index) => {
            return (
              <button
                onClick={() => swiper.slideTo(index)}
                key={index}
                className={
                  "md:p-2.5 p-1 flex items-center justify-center " +
                  (index == activeSlide && "active")
                }
              >
                <img
                  src={logoUrl}
                  alt="img"
                  className="max-w-20 h-10 md:h-auto"
                  width="80"
                  height="80"
                  loading="lazy"
                />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
